module.exports = __webpack_public_path__ + "img/photo_mb_menu.cfeca867.png";